import request from '@/utils/http';
import { prefix } from '@/utils/prefix';
import { unwrapResponse } from '@/utils/http/types';
import { storageGetItem } from '@/utils/storage';

/**
 * 上传文件
 */
export async function uploadFile(file, category) {
  const formData = new FormData();
  formData.append('file', file);
  if (category) {
    formData.append('category', category);
  }
  return unwrapResponse(request.post(`${prefix.storage}/file/upload`, formData));
}

/**
 * 分页查询文件列表
 */
export async function getFilePage(params) {
  return unwrapResponse(request.get(`${prefix.storage}/file/page`, {
    params
  }));
}

/**
 * 删除文件
 */
export async function deleteFile(id) {
  return unwrapResponse(request.delete(`${prefix.storage}/file/${id}`));
}

/**
 * 下载文件
 */
export async function downloadFile(id, filename) {
  void filename;
  const token = storageGetItem('token') || '';
  console.log(`${prefix.storage}/file/${id}/download`);
  const res = await fetch(`${prefix.storage}/file/${id}/download`, {
    method: 'GET',
    headers: token ? {
      Authorization: `Bearer ${token}`
    } : {},
    credentials: 'include'
  });
  return res;
}